import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

export default function useNotAuthorized() {
  const navigate = useNavigate()
  const onNotAuthorized = (event) => {
    if (event.data === 'NotAuthorized') {
      toast.error('Session Expired')
      window.localStorage.removeItem(process.env.REACT_APP_XITS_USER_KEY)
      window.localStorage.removeItem(process.env.REACT_APP_XITS_TOKEN_KEY)
      navigate('/login')
    }
  }
  useEffect(() => {
    window.addEventListener('message', onNotAuthorized, false)
    return () => {
      window.removeEventListener('message', onNotAuthorized, false)
    }
  }, [])
}
